export const API_BASE_URL = process.env.REACT_APP_BIRDMAP_API_BASE_URL || 'http://localhost:8081';
export const ECOREGION_ENRICHMENT_ENDPOINT = '/api/ecoregions/enrich';
